import script from "./SectionConfigModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SectionConfigModal.vue?vue&type=script&setup=true&lang=js"

import "./SectionConfigModal.vue?vue&type=style&index=0&id=2e351e7a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2e351e7a"]])

export default __exports__